export const VSCCoreProductCodes: string[] = ['APMI', 'APME'];
export const VSCNonCoreProductCodes: string[] = ['APOI', 'APMO'];
export const VSCProductCodes: string[] = [...VSCCoreProductCodes, ...VSCNonCoreProductCodes];
export const MutedProductCodes: string[] = ['YMBG', 'YMGP', 'YMRS'];